$(function(){
  
  	var distribuidoresHtml = document.querySelector('#distribuidores');
    var estadoLista = document.querySelector('#estado');
    var ciudadLista = document.querySelector('#ciudad');
    var distribuidores = null;
  
  var url_mexico = "https://encoalimentos.com/pages/mexico";
    var ur_actual = window.location.href;
  
  	if(ur_actual.indexOf(url_mexico) >= 0){
        obtener();
    }


    function obtener(){
      	let url = 'https://cdn.shopify.com/s/files/1/0128/2693/5360/t/37/assets/mexico.json?v=0.172'
        //let url = 'assets/json/mexico.json'
        fetch(url)
            .then( res => res.json() )
            .then( datos => {
                distribuidores = datos;
                enlistarEstado(datos);
            });
    }


    function enlistarEstado(datos){
        let id = 0;
        estadoLista.innerHTML = `<option value="todos">Seleccionar Estado</option>`;

        for(let valor of datos){
            data = valor.estado.toLowerCase().split(" ").join("-");
            estadoLista.innerHTML += `<option value=${id} data-estado="${data}">${valor.estado}</option>`;
            id++;
        }
        estadoLista.addEventListener("change", function(){enlistarCiudad(0)});
      
      	//	Revisar si alguien entró por url
        var urlFinal = window.location.pathname.replace("/pages/mexico/","");
      		partes = urlFinal.split("/");

        if(partes.length < 3 && !isNaN(partes[0])){
          	console.log("Entrooo")
           	let id = 1 + parseInt(partes[0]);
          	console.log(id)
            $('#estado > option').eq(id).attr('selected','selected');
 		   	enlistarCiudad(1);
          	
          	let ciudad = getParameterByName('ciudad');
          	if(ciudad!=null && ciudad!="0"){
          		$('#ciudad > option').eq(ciudad).attr('selected','selected');
          		seleccionarCiudad();
          	}
        }
	
          
    }

    function enlistarCiudad(tipoUrl){
        let valor  = estadoLista.options[estadoLista.selectedIndex].value;
        let texto  = estadoLista.options[estadoLista.selectedIndex].innerHTML;
      	//let newUrl = "/pages/mexico/"+texto.toLowerCase().split(" ").join("-");

      	$('.page-header h1').text(texto);
      	if(tipoUrl==0)
      		history.pushState(null, "","/pages/mexico/"+ valor);
      
        if(valor !== "todos"){
            let ciudades = distribuidores[valor].ciudades;

            ciudadLista.innerHTML = ``;
            if(ciudades.length > 0){
                if(ciudades.length > 1)
                    ciudadLista.innerHTML = `<option value="todos" data-id="0">Todos</option>`;
                ciudadLista.addEventListener("change", seleccionarCiudad);
                mostrarCiudadesTodos(valor);
            }
            else
                distribuidoresHtml.innerHTML = `<p class="p-5 text-center fadeIn">NO CONTAMOS CON DISTRIBUIDORES EN ESTE ESTADO</p>`


			let id = 1;
            for(let ciudad of ciudades){
                //    NO es necesario pasar el atributo data
                data = ciudad.ciudad.toLowerCase().split(" ").join("-");
              ciudadLista.innerHTML += `<option value="${data}"  data-id="${id}">${ciudad.ciudad}</option>`;
              id++;
            }
        }

    }

    function revisarNumeroDistribuidoresXciudad(estado){
        let ciudades = distribuidores[estado].ciudades;
        for(let ciudad of ciudades){
            if(ciudad.distribuidores.length > 1)
                return 2;
        }

        return 1;
    }

    function codigoImagen(distribuidores){
        let imagen = distribuidores.imagen;
        if(imagen=="")
            return `<span class="not-image"></span>`;

        return `<img class=" img-fluid" src="${imagen}" alt="card image">`;
    }

    function codeFbPagina(distribuidores,numDistribuidores){
        let codigoHtml = "";

        let facebook = distribuidores.facebook;
        let facebookUrl = distribuidores.facebook_url;
        let pagina = distribuidores.pagina;
        let paginaUrl = distribuidores.pagina_url;

        if(facebook!="")
            codigoHtml = `<li><span>Facebook: </span><a href="${facebookUrl}">${facebook}</a></li>`;
        if(pagina!="")
            codigoHtml = `<li><span>Web: </span><a href="${paginaUrl}">${pagina}</a></li>`;

        if(numDistribuidores > 1){
                codigoHtml = `<div class="card-body text-center">
                                <ul class="link_social">
                                    ${codigoHtml}
                                </ul>
                              </div>`;
        }

        return codigoHtml;
    }

    function ordenamientoFila(estado){
        let ciudades = distribuidores[estado].ciudades;
        let blockHtml = "";

        for(let ciudad of ciudades){
            data = ciudad.ciudad.toLowerCase().split(" ").join("-");
            blockHtml += `<section id="team" class="ciudades fadeIn ${data}" >
                            <div class="container">
                                <h5 class="section-title">${ciudad.ciudad}</h5>
                                <div class="row">`;

            for(let distribuidores of ciudad.distribuidores){
                //    Detectar qué imagen poner
                let numDistribuidores = distribuidores.sucursales.length;
                let imagenHtml = codigoImagen(distribuidores);
                let facebookPaginaHtml = codeFbPagina(distribuidores,numDistribuidores);


                blockHtml += `<div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="image-flip">
                                    <div class="mainflip">
                                        <div class="frontside">
                                            <div class="card pt-2">
                                                <div class="card-body text-center">
                                                    <p>${imagenHtml}</p>
                                                    <h4 class="card-title">${distribuidores.nombre}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="backside align-self-start">
                                            <div class="card pt-2">`;

                for(let sucursal of distribuidores.sucursales){
                    blockHtml += `<div class="card-body text-center">
                                    <h4 class="card-title">${sucursal.nombre}</h4>
                                    <ul class="link_social">
                                        <li><span>Dirección: </span>${sucursal.direccion}</li>
                                        <li><span>Teléfono: </span><a href="${sucursal.telefono_link}">${sucursal.telefono}</a></li>`
                    if(numDistribuidores == 1) blockHtml += facebookPaginaHtml;
                    blockHtml +=     `</ul>
                                  </div>`
                }
                if(numDistribuidores > 1) blockHtml += facebookPaginaHtml;
                blockHtml += `  </div>
                             </div>`;

                blockHtml += `      </div>
                                </div>
                             </div>`;
            }


            blockHtml += `      </div>
                            </div>
                         </section>`;

        }

        return blockHtml;

    }

    function ordenamientoColumna(estado){
        let ciudades = distribuidores[estado].ciudades;

        let blockHtml = `<section id="team">
                            <div class="container">
                                <div class="row">`;

        for(let ciudad of ciudades){

            //    Detectar qué imagen poner
            let numDistribuidores = ciudad.distribuidores[0].sucursales.length;
            let imagenHtml = codigoImagen(ciudad.distribuidores[0]);
            let facebookPaginaHtml = codeFbPagina(ciudad.distribuidores[0],numDistribuidores);


            data = ciudad.ciudad.toLowerCase().split(" ").join("-");
            blockHtml += `<div class="col-xs-12 col-sm-6 col-md-4 fadeIn ${data} ciudades">
                            <h5 class="section-title">${ciudad.ciudad}</h5>
                            <div class="image-flip">
                                <div class="mainflip">
                                    <div class="frontside">
                                        <div class="card pt-2">
                                            <div class="card-body text-center">
                                                <p>${imagenHtml}</p>
                                                <h4 class="card-title">${ciudad.distribuidores[0].nombre}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="backside align-self-start">
                                        <div class="card pt-2">`;
            //    lista de sucursales
            for(let sucursal of ciudad.distribuidores[0].sucursales){
                blockHtml += `<div class="card-body text-center">
                                <h4 class="card-title">${sucursal.nombre}</h4>
                                <ul class="link_social">
                                    <li><span>Dirección: </span>${sucursal.direccion}</li>
                                    <li><span>Teléfono: </span><a href="${sucursal.telefono_link}">${sucursal.telefono}</a></li>`
                if(numDistribuidores == 1) blockHtml += facebookPaginaHtml;
                blockHtml +=     `</ul>
                              </div>`
            }

            if(numDistribuidores > 1) blockHtml += facebookPaginaHtml;

            blockHtml += `              </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>`;

        }

        blockHtml += `        </div>
                          </div>
                      </section>`;

        return blockHtml;

    }

    function mostrarCiudadesTodos(estado){

        let ordenamiento = revisarNumeroDistribuidoresXciudad(estado);
        distribuidoresHtml.innerHTML = (ordenamiento==2) ? ordenamientoFila(estado) : ordenamientoColumna(estado);

    }


    function seleccionarCiudad(){
        let option = ciudadLista.options[ciudadLista.selectedIndex];
      	var id = option.dataset.id;
      
      	var urlActual = window.location.pathname;
      	var ciudad = (urlActual.substr(-1,1)=="/") ? "?ciudad="+ id : "/?ciudad="+ id;
      
      	history.pushState(null, "",urlActual+ciudad);

        if(option.value == 'todos'){
            $('.ciudades').css('display','none');
            $('.ciudades').css('display','block');
        }else{
            $('.ciudades').css('display','none');
            $('.'+option.value).css('display','block');
        }
    
     
    }
  
  	function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  	
  
});
